/*******************************************************************************
 * Project：Kenshin
 * Summary:
 * 　　Shared methods
 * History：
 *      NghiaNX 2021/04/23  Create
 ******************************************************************************//*
*/
import { Injectable, NgZone } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import PerfectScrollbar from 'perfect-scrollbar';
import { CommonService } from 'src/app/services/common.service';
@Injectable({
    providedIn: 'root'
})

export class Utility {
    lstYear = [];
    lstCoDiv = [];
    lstGender = [];
    lstCourseDiv = [];
    lstJudgmentStatus = [];
    lstPersonFamilyDiv = [];
    strCurrentLang = '';
    constructor(
        private translate: TranslateService,
        private ngZone: NgZone,
        private commonSrv: CommonService
    ) { }
    resetZoomBrowser() {
        $('.wrapper-body').scrollTop(0);
    }
    // check is null or empty
    isNullOrEmpty(str: any): boolean {
        return str === '' || str === undefined || str === null || str === 'undefined' || str === 'null';
    }
    // check is null
    isNull(str: any): boolean {
        return str === undefined || str === null || str === 'undefined' || str === 'null';
    }

    // check is null or empty
    isNullOrBlank(val: any): boolean {
        const str = this.isNullOrEmpty(val) ? '' : val.toString().trim();
        return this.isNullOrEmpty(str);
    }

    // isShow = true: show loading icon
    // isShow = false: hide loading icon
    showLoadingIcon(isShow: boolean) {
        const item = document.getElementById('iconloading');
        if (isShow) {
            item.classList.remove('hidden');
            return;
        }
        item.classList.add('hidden');
    }

    /**
     * (@param o ) : an object value = true or false
     * return: true if (JSON.stringify(o) === 'true'); false if other
     */
    objectToBoolean(o: any) {
        return (/true/i).test(JSON.stringify(o));
    }

    // Check input character is halfwidth
    isHalfWidth(ch: string): boolean {
        const eaw: any = require('eastasianwidth');
        if (eaw.length(ch) === 1) {
            return true;
        } else {
            return false;
        }
    }
    // Check input string is HighSurrogate pairs
    isHighSurrogate(inputString: string): boolean {
        const highSurrogate: RegExp = /[\uD800-\uDBFF]/g;
        return highSurrogate.test(inputString);
    }

    // Check input string is LowSurrogate pairs
    isLowSurrogate(inputString: string): boolean {
        const lowSurrogate: RegExp = /[\uDC00-\uDFFF]/g;
        return lowSurrogate.test(inputString);
    }

    // Check browser used is IE
    isIEBrowser(): boolean {
        const ua: string = window.navigator.userAgent;
        const trident: number = ua.indexOf('Trident/');
        if (trident > 0) {
            return true;
        } else {
            return false;
        }
    }

    // Check input string is number
    isNumber(inputString: string): boolean {
        const numberRegExp: RegExp = new RegExp('^[0-9]*$');
        return numberRegExp.test(inputString);
    }

    // Check input string is alphanumeric
    isAlphaNumeric(inputString: string): boolean {
        const alphaNumericRegExp: RegExp = new RegExp('^[0-9A-Za-z]*$');
        return alphaNumericRegExp.test(inputString);
    }

    toHalfWidth(inputString: string): string {
        return inputString.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
    }

    toFullWidth(inputString: string): string {
        return inputString.replace(/[A-Za-z0-9]/g, (s) => {
            return String.fromCharCode(s.charCodeAt(0) + 0xFEE0);
        });
    }
    TrimAll(pVal: string) {
        return this.ReplaceAll(pVal, ' ', '');
    }
    ReplaceAll(pVal: string, pChar: string, pRplChar: string) {
        if (this.isNullOrEmpty(pVal)) {
            return pVal;
        }
        const regex = new RegExp('[' + pChar + ']', 'gi');
        return pVal.replace(regex, pRplChar);
    }
    /**
     * parse sessionStorage.authorizationData
     */
    getLocalAuthInfo() {
        const data: AuthorizationData = JSON.parse(sessionStorage.authorizationData);
        return data;
    }
    formatDate(date: any, format: string, isType = true) {
        const d = new Date(date);
        let month = isType ? '' + (d.getMonth() + 1) : date.month;
        let day = isType ? '' + d.getDate() : date.day;
        const year = isType ? d.getFullYear() : date.year;
        if (Number(month) < 10) {
            month = '0' + month;
        }
        if (Number(day) < 10) {
            day = '0' + day;
        }
        return [year, month, day].join(format);
    }
    formatPostal(pPostalCode: string) {
        // 20250120 #18640 modify strat
        // if (pPostalCode.length < 7) {
        //     return pPostalCode;
        // }
        /* 20250208 #18640 modify start */
        // if (pPostalCode.length < 4) {
        if (pPostalCode.length != 7) {
        /* 20250208 #18640 modify end */
            return pPostalCode;
        }
        // 20250120 #18640 modify end
        const str = this.TrimAll(pPostalCode);
        return str.substring(0, 3) + ' ' + str.substring(3);
    }
    formatDateNoYear(date: any, format: string, isType = true) {
        const d = new Date(date);
        let month = isType ? '' + (d.getMonth() + 1) : date.month;
        let day = isType ? '' + d.getDate() : date.day;
        const year = isType ? d.getFullYear() : date.year;
        if (Number(month) < 10) {
            month = '0' + month;
        }
        if (Number(day) < 10) {
            day = '0' + day;
        }
        return [month, day].join(format);
    }
    daysdifference(firstDate: string, secondDate: string) {
        const firstDates = firstDate.slice(0, 4) + ' / ' + firstDate.slice(4, 6) + ' / ' + firstDate.slice(6);
        const day = Math.floor((Date.parse(secondDate) - Date.parse(firstDates)) / 86400000);
        return day;
    }
    formatDateTime(date: Date, format: string) {
        const year = date.getFullYear();
        let month = '' + (date.getMonth() + 1);
        let day = '' + date.getDate();
        let hours = '' + date.getHours();
        let minnutes = '' + date.getMinutes();
        if (Number(month) < 10) {
            month = '0' + month;
        }
        if (Number(day) < 10) {
            day = '0' + day;
        }
        if (Number(hours) < 10) {
            hours = '0' + hours;
        }
        if (Number(minnutes) < 10) {
            minnutes = '0' + minnutes;
        }
        return [year, month, day, hours, minnutes].join(format);
    }
    stringFormat(lstString: string[]): string {
        let theString = lstString[0];

        for (let i = 1; i < lstString.length; i++) {
            // "gm" = RegEx options for Global search (more than one instance)
            // and for Multiline search
            const regEx = new RegExp('\\{' + (i - 1) + '\\}', 'gm');
            theString = theString.replace(regEx, lstString[i]);
        }
        return theString;
    }
    stringToDate(value: string) {
        const year = value.substring(0, 4);
        const month = value.substring(4, 6);
        const day = value.substring(6, 8);
        return new Date(Number(year), Number(month) - 1, Number(day));
    }
    stringToDateTime(value: string) {
        const year = value.substring(0, 4);
        const month = value.substring(4, 6);
        const day = value.substring(6, 8);
        const hours = value.substring(8, 10);
        const minutes = value.substring(10);
        return new Date(Number(year), Number(month) - 1, Number(day), Number(hours), Number(minutes));
    }
    activeSelected(arrDt: any[], idx: number) {
        arrDt.map(it => it.selected = false);
        arrDt[idx].selected = true;
    }
    calculateAgeTypOne(dob: any, ageCalDiv: string, meetDay: string) {
        let dom = new Date();
        dom = this.getDateCalculateAge(ageCalDiv, meetDay);
        return this.AgeCalculate(dom, dob);
    }

    getDateCalculateAge(ageCalDiv: string, meetDay: string) {
        let dom = new Date();
        if (!this.isNullOrBlank(meetDay)) {
            const strMeetYear = meetDay?.substring(0, 4);
            if (!this.isNullOrEmpty(strMeetYear)) {
                switch (ageCalDiv) {
                    case '2':
                        const Case2Year = Number(meetDay) >= Number(strMeetYear + '0401') ? Number(strMeetYear) + 1 : Number(strMeetYear);
                        dom = new Date(Case2Year, 2, 31);
                        break;
                    case '3':
                        const Case3Year = Number(meetDay) >= Number(strMeetYear + '0401') ? Number(strMeetYear) : Number(strMeetYear) - 1;
                        dom = new Date(Case3Year, 11, 31);
                        break;
                    case '4':
                        // 20250113 modify #23633 start
                        // const Case4Year = Number(meetDay) >= Number(strMeetYear + '0402') ? Number(strMeetYear) + 1 : Number(strMeetYear);
                        const Case4Year = Number(meetDay) >= Number(strMeetYear + '0401') ? Number(strMeetYear) + 1 : Number(strMeetYear);
                        // 20250113 modify #23633 end
                        dom = new Date(Case4Year, 3, 1);
                        break;
                    default:
                        dom = new Date(Number(strMeetYear), Number(meetDay.substring(4, 6)) - 1, Number(meetDay.substring(6)));
                        break;
                }
            }
        }
        return dom;
    }

    private AgeCalculate(dom: Date, dob: any) {
        let age = dom.getFullYear() - dob.getFullYear();
        const m = dom.getMonth() - dob.getMonth();
        if (m < 0 || (m === 0 && dom.getDate() < dob.getDate())) {
            age--;
        }
        return age.toString();
    }

    calculateAge(birthday: Date, checkDate: string) {
        const checkDateEMpty = this.isNullOrEmpty(checkDate);
        const currDate = new Date();
        const calDate = checkDateEMpty ? currDate : this.stringToDate(currDate.getFullYear() + checkDate);
        const ageDifMs = calDate.getTime() - birthday.getTime();
        const age = Math.floor(ageDifMs / (1000 * 60 * 60 * 24 * 365.25));
        return age.toString();
    }
    calculateAge2(dob: any, ageCalDiv: string, meetDay: string) {
        let dom = new Date();
        if (!this.isNullOrBlank(meetDay)) {
            const strMeetYear = meetDay?.substring(0, 4);
            if (!this.isNullOrEmpty(strMeetYear)) {
                switch (ageCalDiv) {
                    case '2':
                        const Case2Year = Number(meetDay) >= Number(strMeetYear + '0401') ? Number(strMeetYear) + 1 : Number(strMeetYear);
                        dom = new Date(Case2Year, 2, 31);
                        break;
                    case '3':
                        const Case3Year = Number(meetDay) >= Number(strMeetYear + '0401') ? Number(strMeetYear) : Number(strMeetYear) - 1;
                        dom = new Date(Case3Year, 11, 31);
                        break;
                    case '4':
                        // 20250212 modify #23633 start
                        // const Case4Year = Number(meetDay) >= Number(strMeetYear + '0402') ? Number(strMeetYear) + 1 : Number(strMeetYear);
                        const Case4Year = Number(meetDay) >= Number(strMeetYear + '0401') ? Number(strMeetYear) + 1 : Number(strMeetYear);
                        // 20250212 modify #23633 end
                        dom = new Date(Case4Year, 3, 1);
                        break;
                    default:
                        dom = new Date(Number(strMeetYear), Number(meetDay.substring(4, 6)) - 1, Number(meetDay.substring(6)));
                        break;
                }
            }
        }
        // 20250212 modify #23633 start
        // const ageDifMs = dom.getTime() - dob.getTime(); 
        // const age = Math.floor(ageDifMs / (1000 * 60 * 60 * 24 * 365.25));
        const domMonth = (dom.getMonth() + 1).toString().length == 1 ? '0' + (dom.getMonth() + 1).toString() : (dom.getMonth() + 1).toString();
        const domDay = (dom.getDate()).toString().length == 1 ? '0' + (dom.getDate()).toString() : (dom.getDate()).toString();
        const dobMonth = (dob.getMonth() + 1).toString().length == 1 ? '0' + (dob.getMonth() + 1).toString() : (dob.getMonth() + 1).toString();
        const dobDay = (dob.getDate()).toString().length == 1 ? '0' + (dob.getDate()).toString() : (dob.getDate()).toString();
        const age = domMonth + domDay >= dobMonth + dobDay ? dom.getFullYear() - dob.getFullYear() : dom.getFullYear() - dob.getFullYear() - 1;
        // 20250212 modify #23633 end
        return age.toString();
    }
    UpDownTableRecords(arrData: any[], move: string) {
        const currSelectIdx = arrData.findIndex(f => f.selected);
        let newSelectIdx = -1;
        switch (move) {
            case 'Up':
                if (currSelectIdx > 0) {
                    newSelectIdx = currSelectIdx === -1 ? arrData.length - 1 : currSelectIdx - 1;
                }
                break;
            default:
                if (currSelectIdx < arrData.length - 1) {
                    newSelectIdx = currSelectIdx + 1;
                }
                break;
        }
        return newSelectIdx;
    }
    TranslateCurrentLang() {
        let currency = '';
        const currentLang = this.translate.currentLang;
        switch (currentLang) {
            case 'en':
                currency = 'USD';
                break;
            case 'ja':
                currency = 'JPY';
                break;
            case 'vi':
                currency = 'VND';
                break;
            default:
                currency = 'JPY';
                break;
        }
        return currency;
    }
    getFullNameDay(dateStr) {
        const intWeekday = new Date(dateStr).getDay();
        let strWeekday;
        switch (intWeekday) {
            case 0:
                strWeekday = 'STR_SUNDAY_FULL';
                break;
            case 1:
                strWeekday = 'STR_MONDAY_FULL';
                break;
            case 2:
                strWeekday = 'STR_TUESDAY_FULL';
                break;
            case 3:
                strWeekday = 'STR_WEDNESDAY_FULL';
                break;
            case 4:
                strWeekday = 'STR_THURSDAY_FULL';
                break;
            case 5:
                strWeekday = 'STR_FRIDAY_FULL';
                break;
            case 6:
                strWeekday = 'STR_SATURDAY_FULL';
                break;
            default:
                strWeekday = null;
                break;
        }
        return strWeekday;
    }
    getNameDay(intWeekday) {
        let strWeekday;
        switch (intWeekday) {
            case 1:
                strWeekday = 'STR_SUNDAY';
                break;
            case 2:
                strWeekday = 'STR_MONDAY';
                break;
            case 3:
                strWeekday = 'STR_TUESDAY';
                break;
            case 4:
                strWeekday = 'STR_WEDNESDAY';
                break;
            case 5:
                strWeekday = 'STR_THURSDAY';
                break;
            case 6:
                strWeekday = 'STR_FRIDAY';
                break;
            case 7:
                strWeekday = 'STR_SATURDAY';
                break;
            default:
                strWeekday = null;
                break;
        }
        return strWeekday;
    }
    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    addPerfectScrollBar() {
        this.ngZone.runOutsideAngular(() => {
            if (window.outerWidth > 767){
                $('.scrollbar').each(function () {
                    $('.ps__thumb-x , .ps__thumb-y').attr('tabindex', '-1');
                    if (!$(this).hasClass('ps')) {
                        const ps = new PerfectScrollbar(this);
                        $(window).on('resize', () => {
                            ps.update();
                        });
                        document.querySelector('body').addEventListener('touchstart', () => {
                            setTimeout(() => {
                                ps.update();
                            }, 10);
                        });
                        document.querySelector('body').addEventListener('click', () => {
                            setTimeout(() => {
                                ps.update();
                            }, 10);
                        });
                        document.querySelector('body').addEventListener('mouseover', () => {
                            ps.update();
                        }, false);
                    }
                });
            }
        });
    }

    dateToString(date: Date) {
        if (date) {
            const year = date.getFullYear().toString();
            const month = date.getMonth() + 1;
            let strMonth = month.toString();
            if (month < 10) {
                strMonth = '0' + strMonth;
            }
            const day = date.getDate();
            let strDay = day.toString();
            if (day < 10) {
                strDay = '0' + strDay;
            }
            return year + strMonth + strDay;
        }
        return null;
    }
    checkTimeLifeApi(d1: Date) {
        const curDate = new Date();
        const time1 = d1.getTime();
        const time2 = curDate.getTime();
        const sec = (time2 - time1) / 1000;
        return sec;
    }
    formatCurrency(strCurrency: string) {
        if (this.isNullOrEmpty(strCurrency)) {
            return strCurrency;
        }
        strCurrency = this.ReplaceAll(this.TrimAll(strCurrency), ',', '');
        let reCUrrency = '';
        if (strCurrency.length > 3) {
            const arrChar = [];
            let count = 1;
            for (let i = strCurrency.length - 1; i >= 0; i--) {
                arrChar.push(strCurrency[i]);
                if (count % 3 === 0) {
                    arrChar.push(',');
                }
                count++;
            }
            const reverAr = arrChar.reverse();
            reCUrrency = reverAr.join('');
        } else {
            reCUrrency = strCurrency;
        }
        const FstComma = reCUrrency.indexOf(',');
        if (FstComma === 0) {
            reCUrrency = reCUrrency.substring(1);
        }
        return reCUrrency;
    }
    fullWithCharacter(value: any) {
        let isFullWidth = false;
        if (!this.isNullOrEmpty(value)) {
            const strValue: string = value?.trim();
            const reg = new RegExp(/^[０-９Ａ-Ｚぁ-んァ-ン一-龥]/);
            for (const char of strValue) {
                if (reg.test(char)) {
                    isFullWidth = true;
                    break;
                }
            }
        }
        return isFullWidth;
    }
    limitShowText(value: any, maxLength: number) {
        if (!this.isNullOrEmpty(value)) {
            const isFullWidth = this.fullWithCharacter(value);
            return isFullWidth ? value.substring(0, 30) : value.substring(0, maxLength);
        } else {
            return '';
        }
    }
    trimObj(obj: any) {
        if (obj === null && !Array.isArray(obj) && typeof obj !== 'object') { return obj; }
        try {
            return Object.keys(obj).reduce((acc, key) => {
                switch (typeof obj[key]) {
                    case 'string':
                        acc[key] = obj[key].trim();
                        break;
                    case 'object':
                        acc[key] = obj[key];
                        break;
                    default:
                        acc[key] = obj[key];
                        break;
                }
                return acc;
            }, Array.isArray(obj) ? [] : {});
        } catch (error) {
            console.log(error);
        }
    }
    getLstCoDiv() {
        const lstCoDiv = [];
        lstCoDiv.push({ code: '', value: '', active: true });
        lstCoDiv.push({ code: '1', value: this.translate.instant('STR_ENTERPRISE'), active: false });
        lstCoDiv.push({ code: '2', value: this.translate.instant('STR_HEALTH_INSURANCE_ASSOCIATION'), active: false });
        lstCoDiv.push({ code: '3', value: this.translate.instant('STR_PERSONAL'), active: false });
        return lstCoDiv;
    }
    getLstGender() {
        const lstGender = [];
        lstGender.push({ code: '', value: '', active: true });
        lstGender.push({ code: '1', value: this.translate.instant('STR_GENDER_MALE'), active: false });
        lstGender.push({ code: '2', value: this.translate.instant('STR_GENDER_FEMALE'), active: false });
        return lstGender;
    }
    getLstYear() {
        const lstYear = [];
        lstYear.push({ code: 1, value: this.translate.instant('STR_TAISHO') });
        lstYear.push({ code: 2, value: this.translate.instant('STR_SHOWA') });
        lstYear.push({ code: 3, value: this.translate.instant('STR_HEISEI') });
        lstYear.push({ code: 4, value: this.translate.instant('STR_REIWA') });
        lstYear.push({ code: 5, value: this.translate.instant('STR_CHRISTAN_ERA') });
        return lstYear;
    }
    getLstCourseDiv() {
        const lstCourseDiv = [];
        lstCourseDiv.push({ code: '0', value: this.translate.instant('STR_ALL'), active: true });
        lstCourseDiv.push({ code: '1', value: this.translate.instant('STR_REGULAR_MEDICAL_EXAM'), active: false });
        lstCourseDiv.push({ code: '2', value: this.translate.instant('STR_HUMAN_DOCK'), active: false });
        return lstCourseDiv;
    }
    getLstPersonFamilyDiv() {
        const lstPersonFamilyDiv = [];
        lstPersonFamilyDiv.push({ code: '', value: '', active: true });
        lstPersonFamilyDiv.push({ code: '1', value: this.translate.instant('STR_PERSON'), active: false });
        lstPersonFamilyDiv.push({ code: '2', value: this.translate.instant('STR_FAMILY'), active: false });
        return lstPersonFamilyDiv;
    }
    getLstJudgmentStatus() {
        const lstJudgmentStatus = [];
        lstJudgmentStatus.push({ code: '1', value: this.translate.instant('STR_JUDGEDIV_UNDECIDE'), active: true });
        lstJudgmentStatus.push({ code: '2', value: this.translate.instant('STR_JUDGDIV_COMPLETED'), active: false });
        lstJudgmentStatus.push({ code: '3', value: this.translate.instant('STR_JUDGDIV_FINAL_COMPLETED'), active: false });
        return lstJudgmentStatus;
    }
    areAnyFullWidth(input: string) {
        const fullWidthRegex = /^[ァ-ン]|[０-９]|[[Ａ-ｚ]$/;
        for (let i = 0; i < input.length; i++) {
            const char = input.charAt(i);
            const isFullWidth = fullWidthRegex.test(char);
            if (isFullWidth) {
                return true;
            }
        }
        return false;
    }
    checkDialogModalMessage() {
        let blnCheckShow = false;
        if ($('#dialog-modal-message').length > 0) {
            blnCheckShow = true;
        }
        return blnCheckShow;
    }
    checkJPContry() {
        return (!this.isNullOrBlank(localStorage.Country) && localStorage.Country === 'JP');
    }
    compareTwoDate(d1: any, d2: any) {
        const strD1 = this.isNullOrBlank(d1) ? '' : this.dateToString(d1);
        const strD2 = this.isNullOrBlank(d2) ? '' : this.dateToString(d2);
        return (strD2 !== strD1);
    }
    setAreaNumber(pValue: string) {
        let phoneNum = '';
        if (this.isNullOrBlank(pValue)) {
            return phoneNum;
        }
        const value = pValue.trim();
        if (value.length === 11) {
            phoneNum = value.substring(0, 3) + ' ' + value.substring(3, 7) + ' ' + value.substring(7);
            return phoneNum;
        }
        const jaAreaNum = value.substring(0, 2);
        switch (jaAreaNum) {
            case '01':
                phoneNum = this.setCaseOne(value);
                break;
            case '02':
                phoneNum = this.setCaseTwo(value);
                break;
            case '03':
                phoneNum = value.substring(0, 2) + ' ' + value.substring(2, 6) + ' ' + value.substring(6);
                break;
            case '04':
                phoneNum = this.setCaseFour(value);
                break;
            case '05':
                phoneNum = this.setCaseFive(value);
                break;
            case '06':
                phoneNum = value.substring(0, 2) + ' ' + value.substring(2, 6) + ' ' + value.substring(6);
                break;
            case '07':
                phoneNum = this.setCaseSeven(value);
                break;
            case '08':
                phoneNum = this.setCaseEight(value);
                break;
            default:
                phoneNum = this.setCaseNine(value);
                break;
        }
        return phoneNum;
    }
    setCaseOne(value: string) {
        let arePhoneNum = '';
        const thirdNum = value.substring(2, 3);
        const fourNumChar = value.substring(0, 4);
        const fiveNumChar = value.substring(0, 5);
        if (thirdNum >= '1' && thirdNum <= '6') {
            switch (thirdNum) {
                /* 20250212 #23048 add start */
                case '1':
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                    break;
                /* 20250212 #23048 add end */
                case '2':
                    if (fiveNumChar === '01267') {
                        /* 20250212 #23048 modify start */
                        // arePhoneNum = value.substring(0, 5) + ' ' + value.substring(6);
                        arePhoneNum = value.substring(0, 5) + ' ' + value.substring(5, 6) + ' ' + value.substring(6);
                        /* 20250212 #23048 modify end */
                    } else {
                        arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                    }
                    break;
                case '3':
                    if (fiveNumChar === '01372' || fiveNumChar === '01374' || fiveNumChar === '01377' || fiveNumChar === '01392'
                        || fiveNumChar === '01397' || fiveNumChar === '01398') {
                        /* 20250212 #23048 modify start */
                        // arePhoneNum = value.substring(0, 5) + ' ' + value.substring(6);
                        arePhoneNum = value.substring(0, 5) + ' ' + value.substring(5, 6) + ' ' + value.substring(6);
                        /* 20250212 #23048 modify end */
                    } else {
                        arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                    }
                    break;
                case '4':
                    if (fiveNumChar === '01456' || fiveNumChar === '01457' || fiveNumChar === '01466') {
                        /* 20250212 #23048 modify start */
                        // arePhoneNum = value.substring(0, 5) + ' ' + value.substring(6);
                        arePhoneNum = value.substring(0, 5) + ' ' + value.substring(5, 6) + ' ' + value.substring(6);
                        /* 20250212 #23048 modify end */
                    } else {
                        arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                    }
                    break;
                case '5':
                    if (fiveNumChar === '01547' || fiveNumChar === '01558' || fiveNumChar === '01564'
                        || fiveNumChar === '01586' || fiveNumChar === '01587') {
                        /* 20250212 #23048 modify start */
                        // arePhoneNum = value.substring(0, 5) + ' ' + value.substring(6);
                        arePhoneNum = value.substring(0, 5) + ' ' + value.substring(5, 6) + ' ' + value.substring(6);
                        /* 20250212 #23048 modify end */
                    /* 20250212 #23048 modify start */
                    // } else if (fiveNumChar === '01541' || fiveNumChar === '01548' || fiveNumChar === '01551' || fiveNumChar === '01557') {
                    } else if (fourNumChar < '0152' || fourNumChar > '0158') {
                    /* 20250212 #23048 modify end */
                        arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                    } else {
                        arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                    }
                    break;
                case '6':
                    if (fiveNumChar === '01632' || fiveNumChar === '01634' || fiveNumChar === '01635'
                        || fiveNumChar === '01648' || fiveNumChar === '01654'
                        || fiveNumChar === '01655' || fiveNumChar === '01656' || fiveNumChar === '01658') {
                        /* 20250212 #23048 modify start */
                        // arePhoneNum = value.substring(0, 5) + ' ' + value.substring(6);
                        arePhoneNum = value.substring(0, 5) + ' ' + value.substring(5, 6) + ' ' + value.substring(6);
                        /* 20250212 #23048 modify end */
                    } else {
                        arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                    }
                    break;
                default:
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                    break;
            }
        } else if (thirdNum === '7') {
            /* 20250212 #23048 modify start */
            // if (fourNumChar === '0177') {
            if (fourNumChar === '0177' || fourNumChar === '0171' || fourNumChar === '0170') {
            /* 20250212 #23048 modify end */
                arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
            } else {
                arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
            }
        } else if (thirdNum === '8') {
            /* 20250212 #23048 modify start */
            // if (fourNumChar === '0188') {
            if (fourNumChar === '0188' || fourNumChar === '0181' || fourNumChar === '0189' || fourNumChar === '0180') {
            /* 20250212 #23048 modify end */
                arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
            } else {
                arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
            }
        } else if (thirdNum === '9') {
            /* 20250212 #23048 modify start */
            // if (fourNumChar === '0196') {
            if (fourNumChar === '0190' || fourNumChar === '0196' || fourNumChar === '0199') {
            /* 20250212 #23048 modify end */
                arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
            } else {
                arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
            }
        }
        return arePhoneNum;
    }
    setCaseTwo(value: string) {
        let arePhoneNum = '';
        const thirdNum = value.substring(2, 3);
        const fourNumChar = value.substring(0, 4);
        const fiveNumChar = value.substring(0, 5);
        switch (thirdNum) {
            case '2':
            case '3':
            case '4':
                /* 20250212 #23048 modify start */
                // if (fourNumChar === '0222' || fourNumChar === '0227' || fourNumChar === '0236'
                //     || fourNumChar === '0245' || fourNumChar === '0249'
                //     || fiveNumChar === '02230' || fiveNumChar === '02234' || fiveNumChar === '02239') {
                if (fourNumChar === '0221' || fourNumChar === '0222' || fourNumChar === '0227' 
                    || fourNumChar === '0230' || fourNumChar === '0231' || fourNumChar === '0232' || fourNumChar === '0236' || fourNumChar === '0239'
                    || fourNumChar === '0245' || fourNumChar === '0249') {
                /* 20250212 #23048 modify end */
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                }
                break;
            case '5':
                /* 20250212 #23048 modify start */
                // if (fiveNumChar === '02550' || fiveNumChar === '02559' || fiveNumChar === '02555' || fiveNumChar === '02556'
                //     || fiveNumChar === '02560' || fiveNumChar === '02551' || fiveNumChar === '02552' || fiveNumChar === '02553'
                //     || fiveNumChar === '02554' || fiveNumChar === '02575' || fiveNumChar === '02576' || fiveNumChar === '02580'
                //     || fiveNumChar === '02571' || fiveNumChar === '02577' || fiveNumChar === '02578'
                //     || fiveNumChar === '02570' || fiveNumChar === '02579') {
                if (fourNumChar === '0251' || fourNumChar === '0252' || fourNumChar === '0253') {
                /* 20250212 #23048 modify end */
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                }
                break;
            case '6':
                /* 20250212 #23048 modify start */
                // if (fourNumChar === '0262' || fiveNumChar === '02640' || (fiveNumChar >= '02646' && fiveNumChar <= '02649')) {
                if (fourNumChar === '0262') {
                /* 20250212 #23048 modify end */
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                }
                break;
            case '7':
                /* 20250212 #23048 modify start */
                // if (fourNumChar === '0272' || fourNumChar === '0273'
                //     || fiveNumChar === '02780' || fiveNumChar === '02788' || fiveNumChar === '02789') {
                if (fourNumChar === '0271' || fourNumChar === '0272' || fourNumChar === '0273' || fourNumChar === '0275') {
                /* 20250212 #23048 modify end */
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                }
                break;
            case '8':
                /* 20250212 #23048 modify start */
                // if (fiveNumChar === '02830' || fiveNumChar === '02833' || fiveNumChar === '02834' || fourNumChar === '0286'
                //     || (fiveNumChar >= '02890' && fiveNumChar <= '02895')) {
                if (fourNumChar === '0281' || fourNumChar === '0286') {
                /* 20250212 #23048 modify end */
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                }
                break;
            case '9':
                /* 20250212 #23048 modify start */
                // if (fourNumChar === '0298') {
                if (fourNumChar === '0298' || fourNumChar === '0292' || fourNumChar === '0290') {
                /* 20250212 #23048 modify end */
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                }
                break;
            default: // 8 - 9
                arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                break;
        }
        return arePhoneNum;
    }
    setCaseFour(value: string) {
        let arePhoneNum = '';
        const thirdNum = value.substring(2, 3);
        const fourNumChar = value.substring(0, 4);
        const fiveNumChar = value.substring(0, 5);
        switch (thirdNum) {
            case '2':
                /* 20250212 #23048 modify start */
                // if (fourNumChar === '0423' || fourNumChar === '0426' || fourNumChar === '0425' || fourNumChar === '0427'
                //     || fiveNumChar === '04220' || fiveNumChar === '04240' || fiveNumChar === '04242' || fiveNumChar === '04249'
                //     || fiveNumChar === '04280' || fiveNumChar === '04284' || fiveNumChar === '04281' || fiveNumChar === '04285'
                //     || fiveNumChar === '04291' || fiveNumChar === '04297' || fiveNumChar === '04298') {
                //     arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                // } else if (fiveNumChar === '04200') {
                //     arePhoneNum = value.substring(0, 2) + ' ' + value.substring(2, 6) + ' ' + value.substring(6);
                // } else {
                //     arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                // }
                if (fourNumChar === '0422' || fourNumChar === '0428') {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                }
                /* 20250212 #23048 modify end */
                break;
            case '3':
                /* 20250212 #23048 modify start */
                // if (fourNumChar === '0432' || fourNumChar === '0434') {
                if (fourNumChar !== '0436' && fourNumChar !== '0438' && fourNumChar !== '0439') {
                /* 20250212 #23048 modify end */
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                }
                break;
            case '4':
            case '5':
                arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                break;
            case '6':
                /* 20250212 #23048 modify start */
                // if (fourNumChar === '0462' || fourNumChar === '0468' || fiveNumChar === '04640' || fiveNumChar === '04641') {
                if (fourNumChar === '0461' || fourNumChar === '0462' || fourNumChar === '0464' || fourNumChar === '0468' || fourNumChar === '0469') {
                /* 20250212 #23048 modify end */
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                }
                break;
            case '7':
                /* 20250212 #23048 modify start */
                // if (fourNumChar === '0471' || fiveNumChar === '04700' || fiveNumChar === '04709') {
                //     arePhoneNum = value.substring(0, 2) + ' ' + value.substring(2, 6) + ' ' + value.substring(6);
                // } else if (fourNumChar === '0473' || fourNumChar === '0474' || (fiveNumChar >= '04770' && fiveNumChar >= '04772')
                //     || (fiveNumChar >= '04775' && fiveNumChar >= '04777')) {
                if (fourNumChar === '0471' || fourNumChar === '0472' || fourNumChar === '0473' || fourNumChar === '0474' || fourNumChar === '0477') {
                /* 20250212 #23048 modify end */
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                }
                break;
            case '8':
                if (fourNumChar === '0480') {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                }
                break;
            case '9':
                /* 20250212 #23048 modify start */
                // if (fourNumChar === '0492') {
                //     arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                // } else {
                //     arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                // }
                if (fourNumChar === '0493' || fourNumChar === '0494' || fourNumChar === '0495') {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                } else if (fiveNumChar === '04992' || fiveNumChar === '04994' || fiveNumChar === '04996' || fiveNumChar === '04998') {
                    /* 20250212 #23048 modify start */
                    // arePhoneNum = value.substring(0, 5) + ' ' + value.substring(5);
                    arePhoneNum = value.substring(0, 5) + ' ' + value.substring(5, 6) + ' ' + value.substring(6);
                    /* 20250212 #23048 modify end */
                } else {
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                }
                /* 20250212 #23048 modify end */
                break;
            default:
                /* 20250212 #23048 modify start */
                // arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                arePhoneNum = value.substring(0, 2) + ' ' + value.substring(2, 6) + ' ' + value.substring(6);
                /* 20250212 #23048 modify end */
                break;
        }
        return arePhoneNum;
    }
    setCaseFive(value: string) {
        let arePhoneNum = '';
        const thirdNum = value.substring(2, 3);
        const fourNumChar = value.substring(0, 4);
        const fiveNumChar = value.substring(0, 5);
        const sixNumChar = value.substring(0, 6);
        switch (thirdNum) {
            case '3':
                /* 20250212 #23048 modify start */
                // if (fourNumChar === '0531' || fourNumChar === '0532' || fourNumChar === '0533' || fourNumChar === '0536'
                //     || fourNumChar === '0537' || fourNumChar === '0538' || sixNumChar === '053962' || sixNumChar === '053963'
                //     || sixNumChar === '053974' || sixNumChar === '053977') {
                if (fourNumChar !== '0530' && fourNumChar !== '0534' && fourNumChar !== '0535') {
                /* 20250212 #23048 modify end */
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                }
                break;
            case '4':
                if (fourNumChar === '0544' || fourNumChar === '0545' || fourNumChar === '0547' || fourNumChar === '0548') {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                }
                break;
            case '5':
                /* 20250212 #23048 modify start */
                if (fourNumChar === '0552' || fourNumChar === '0559') {
                /* 20250212 #23048 modify end */
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                }
                break;
            case '6':
                arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                break;
            case '7':
                if (fiveNumChar === '05769') {
                    /* 20250212 #23048 modify start */
                    // arePhoneNum = value.substring(0, 5) + ' ' + value.substring(6);
                    arePhoneNum = value.substring(0, 5) + ' ' + value.substring(5, 6) + ' ' + value.substring(6);
                    /* 20250212 #23048 modify end */
                } else {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                }
                break;
            case '8':
                /* 20250212 #23048 modify start */
                // if (fourNumChar === '0582' || fourNumChar === '0583') {
                if (fourNumChar === '0580' || fourNumChar === '0582' || fourNumChar === '0583' || fourNumChar === '0588' || fourNumChar === '0589') {
                /* 20250212 #23048 modify end */
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                }
                break;
            case '9':
                /* 20250212 #23048 modify start */
                // if ((sixNumChar >= '059792' && sixNumChar <= '059796') || sixNumChar === '059799') {
                //     arePhoneNum = value.substring(0, 5) + ' ' + value.substring(6);
                if (fiveNumChar === '05979') {
                    /* 20250212 #23048 modify start */
                    // arePhoneNum = value.substring(0, 5) + ' ' + value.substring(5);
                    arePhoneNum = value.substring(0, 5) + ' ' + value.substring(5, 6) + ' ' + value.substring(6);
                    /* 20250212 #23048 modify end */
                } else if (fourNumChar === '0590' || fourNumChar === '0591' || fourNumChar === '0592' || fourNumChar === '0593') {
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                /* 20250212 #23048 modify end */
                } else {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                }
                break;
            default: // case 0 ,2
                arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                break;
        }
        return arePhoneNum;
    }
    setCaseSeven(value: string) {
        let arePhoneNum = '';
        const thirdNum = value.substring(2, 3);
        const fourNumChar = value.substring(0, 4);
        const fiveNumChar = value.substring(0, 5);
        switch (thirdNum) {
            case '2':
                if (fourNumChar === '0721' || fourNumChar === '0725') {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                }
                break;
            case '3':
                /* 20250212 #23048 modify start */
                // if (fourNumChar === '0734') {
                if (fourNumChar <= '0734') {
                /* 20250212 #23048 modify end */
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                }
                break;
            case '4':
                if (fiveNumChar === '07468') {
                    /* 20250212 #23048 modify start */
                    // arePhoneNum = value.substring(0, 5) + ' ' + value.substring(6);
                    arePhoneNum = value.substring(0, 5) + ' ' + value.substring(5, 6) + ' ' + value.substring(6);
                    /* 20250212 #23048 modify end */
                } else {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                }
                break;
            case '5':
                arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                break;
            case '6':
                /* 20250212 #23048 modify start */
                // if (fiveNumChar === '0762' || fiveNumChar === '0764') {
                if (fourNumChar === '0760' || fourNumChar === '0762' || fourNumChar === '0764' || fourNumChar === '0769') {
                /* 20250212 #23048 modify end */
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                }
                break;
            case '7':
                arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                /* 20250212 #23048 add start */
                if (fourNumChar === '0775' || fourNumChar === '0777') arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                /* 20250212 #23048 add end */
                break;
            case '8':
                arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                break;
            case '9':
                /* 20250212 #23048 modify start */
                // if (fiveNumChar === '07949' || (fiveNumChar >= '07940' && fiveNumChar <= '07945') || fiveNumChar === '07950'
                //     || fiveNumChar === '07955' || fiveNumChar === '07956' || fiveNumChar === '07959'
                //     || fiveNumChar === '07960' || fiveNumChar === '07966' || fiveNumChar === '07967') {
                if (fourNumChar === '0792' || fourNumChar === '0793') {
                /* 20250212 #23048 modify end */
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                }
                break;
            default:
                arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                break;
        }
        return arePhoneNum;
    }
    setCaseEight(value: string) {
        let arePhoneNum = '';
        const thirdNum = value.substring(2, 3);
        const fourNumChar = value.substring(0, 4);
        const fiveNumChar = value.substring(0, 5);
        const sixNumChar = value.substring(0, 6);
        switch (thirdNum) {
            case '2':
                /* 20250212 #23048 modify start */
                // if (fourNumChar === '0823' || fourNumChar === '0824' || fourNumChar === '0826' || fourNumChar === '0827'
                //     || sixNumChar === '082920' || fourNumChar === '08293' || sixNumChar === '082940' || sixNumChar === '082944'
                //     || sixNumChar === '082945' || fiveNumChar === '08295' || fiveNumChar === '08297' || fiveNumChar === '08298') {
                if (fourNumChar != '0821' && fourNumChar != '0822' && fourNumChar != '0825' && fourNumChar != '0828') {
                /* 20250212 #23048 modify end */
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                }
                break;
            case '3':
                /* 20250212 #23048 modify start */
                // if (fiveNumChar === '08387' || fiveNumChar === '08388' || sixNumChar === '083962'
                //     || sixNumChar === '083965' || sixNumChar === '083968') {
                //    arePhoneNum = value.substring(0, 5) + ' ' + value.substring(6);     
                // } else if (fourNumChar === '0833' || fourNumChar === '0834' || fourNumChar === '0835'
                //     || (fiveNumChar >= '08362' && fiveNumChar <= '08369') || (fiveNumChar >= '08372' && fiveNumChar <= '08374')
                //     || fiveNumChar === '08375' || (sixNumChar >= '083760' && sixNumChar <= '083765') || sixNumChar === '083769') {
                if (fiveNumChar === '08387' || fiveNumChar === '08388' || fiveNumChar === '08396') {
                    /* 20250212 #23048 modify start */
                    // arePhoneNum = value.substring(0, 5) + ' ' + value.substring(5);
                    arePhoneNum = value.substring(0, 5) + ' ' + value.substring(5, 6) + ' ' + value.substring(6);
                    /* 20250212 #23048 modify end */
                } else if (fourNumChar >= '0833' && fourNumChar <= '0838') {
                /* 20250212 #23048 modify end */
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                }
                break;
            case '4':
                if (fiveNumChar === '08477') {
                /* 20250212 #23048 modify start */
                //     arePhoneNum = value.substring(0, 5) + ' ' + value.substring(6);
                // } else if (fourNumChar === '0849') {
                    arePhoneNum = value.substring(0, 5) + ' ' + value.substring(5, 6) + ' ' + value.substring(6);
                } else if (fourNumChar < '0845' || fourNumChar === '0849') {
                /* 20250212 #23048 modify end */
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                }
                break;
            case '5':
                if (fiveNumChar === '08512' || fiveNumChar === '08514') {
                    /* 20250212 #23048 modify start */
                    // arePhoneNum = value.substring(0, 5) + ' ' + value.substring(6);
                    arePhoneNum = value.substring(0, 5) + ' ' + value.substring(5, 6) + ' ' + value.substring(6);
                    /* 20250212 #23048 modify end */
                } else {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                }
                break;
            case '6':
                /* 20250212 #23048 modify start */
                // if (fourNumChar === '0862' || fourNumChar === '0864' || fiveNumChar === '08636' || fiveNumChar === '08652'
                //     || (sixNumChar >= '086722' && sixNumChar <= '086724') || sixNumChar === '086552' || sixNumChar === '086553'
                //     || sixNumChar === '086726' || sixNumChar === '086728' || sixNumChar === '086952' || sixNumChar === '086953'
                //     || fiveNumChar === '08680' || fiveNumChar === '08689' || fiveNumChar === '08690' || fiveNumChar === '08694'
                //     || fiveNumChar === '08660' || fiveNumChar === '08699' || (sixNumChar >= '086953' && sixNumChar <= '086959')) {
                if (fourNumChar === '0860' || fourNumChar === '0861' || fourNumChar === '0862' || fourNumChar === '0864') {
                /* 20250212 #23048 modify start */
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                }
                break;
            case '7':
                /* 20250212 #23048 modify start */
                // if (fourNumChar != '0878') {
                if (fourNumChar != '0875' && fourNumChar != '0877' && fourNumChar != '0879') {
                /* 20250212 #23048 modify end */
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                }
                break;
            case '8':
                /* 20250212 #23048 modify start */
                // if (fourNumChar === '0888') {
                if (fourNumChar === '0881' || fourNumChar === '0882' || fourNumChar === '0886' || fourNumChar === '0888') {
                /* 20250212 #23048 modify end */
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                }
                break;
            case '9':
                /* 20250212 #23048 modify start */
                // if (fourNumChar === '0899') {
                if (fourNumChar === '0890' || fourNumChar === '0891' || fourNumChar === '0899') {
                /* 20250212 #23048 modify end */
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                }
                break;
            default:
                arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                break;
        }
        return arePhoneNum;
    }
    setCaseNine(value: string) {
        let arePhoneNum = '';
        const thirdNum = value.substring(2, 3);
        const fourNumChar = value.substring(0, 4);
        const fiveNumChar = value.substring(0, 5);
        switch (thirdNum) {
            case '1':
                arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                break;
            case '2':
            case '3':
                if (fourNumChar === '0920' || fourNumChar === '0930') {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                }
                break;
            case '4':
                /* 20250212 #23048 delete start */
                // if (fiveNumChar === '09496') {
                //     arePhoneNum = value.substring(0, 5) + ' ' + value.substring(6);
                // } else {
                /* 20250212 #23048 delete end */
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                /* 20250212 #23048 delete start */
                // }
                /* 20250212 #23048 delete end */
                break;
            case '5':
                /* 20250212 #23048 add start */
                if (fourNumChar === '0951' || fourNumChar === '0953' || fourNumChar === '0958') {
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                }
                break;
                /* 20250212 #23048 add end */
            case '6':
                /* 20250212 #23048 modify start */
                // if (fourNumChar === '0958' || fourNumChar === '0962' || fourNumChar === '0963' || fourNumChar === '0975') {
                if (fourNumChar < '0964') {
                /* 20250212 #23048 modify start */
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                }
                break;
            /* 20250212 #23048 add start */
            case '7':
                if (fourNumChar === '0970' || fourNumChar === '0971' || fourNumChar === '0975' || fourNumChar === '0976') {
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                }
                break;
            /* 20250212 #23048 add end */
            case '8':
                /* 20250212 #23048 modify start */
                // if (fourNumChar === '0988' || fourNumChar === '0989') {
                if (fourNumChar === '0981' || fourNumChar === '0988' || fourNumChar === '0989') {
                /* 20250212 #23048 modify end */
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                } else if (fiveNumChar === '09802') {
                    /* 20250212 #23048 modify start */
                    // arePhoneNum = value.substring(0, 5) + ' ' + value.substring(6);
                    arePhoneNum = value.substring(0, 5) + ' ' + value.substring(5, 6) + ' ' + value.substring(6);
                    /* 20250212 #23048 modify end */
                } else {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                }
                break;
            case '9':
                if (fiveNumChar === '09912' || fiveNumChar === '09913' || fiveNumChar === '09969') {
                /* 20250212 #23048 modify start */
                //     arePhoneNum = value.substring(0, 5) + ' ' + value.substring(6);
                // } else if (fourNumChar === '0992' || fourNumChar === '0998' || fiveNumChar === '0940' || fiveNumChar === '0947'
                //     || fiveNumChar === '0948') {
                    arePhoneNum = value.substring(0, 5) + ' ' + value.substring(5, 6) + ' ' + value.substring(6);
                } else if (fourNumChar < '0993' || fourNumChar > '0997') {
                /* 20250212 #23048 modify end */
                    arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                } else {
                    arePhoneNum = value.substring(0, 4) + ' ' + value.substring(4, 6) + ' ' + value.substring(6);
                }
                break;
            default:
                arePhoneNum = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6);
                break;
        }
        return arePhoneNum;
    }
    calculateFormatCurrency(currency: any, taxRate = 1, reqPriceFractionCalDiv = null) {
        if (!this.isNullOrEmpty(currency)) {
            let value = currency.toString().trim().replace(/^\+/, '');
            value = +value * taxRate;
            value = this.reqPriceFractionCalDiv(value, reqPriceFractionCalDiv);
            return value.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
        } else {
            return 0;
        }
    }
    reqPriceFractionCalDiv(value, reqPriceFractionCalDiv) {
        switch (reqPriceFractionCalDiv) {
            case '1':
                value = parseInt(value.toString(), 0);
                break;
            case '2':
                value = Math.ceil(value);
                break;
            case '3':
                const totaldecimal = value - parseInt(value.toString(), 0);
                // 20231205 modify #20789 start
                // if (totaldecimal > 0.5) {
                if (totaldecimal >= 0.5) {
                // 20231205 modify #20789 end
                    value = Math.ceil(value);
                } else {
                    value = parseInt(value.toString(), 0);
                }
                break;
            default:
                break;
        }
        return value;
    }
    calcTotalPrice(selectedCourse: any, lstOption: any[], lstSetItem: any[] = []) {
        let option = 0;
        let coPriceOption = 0;
        let insuranceReqPriceOption = 0;
        let otherPriceOption = 0;
        let course = 0;
        let coPriceCourse = 0;
        let insuranceReqPriceCourse = 0;
        let otherPriceCourse = 0;
        let totalA = 0;
        let coPrice = 0;
        let insuranceReqPrice = 0;
        let otherPrice = 0;

        let setItem = 0;
        let coPriceItem = 0;
        let insuranceReqPriceItem = 0;
        let otherPriceItem = 0;

        if (lstOption && lstOption.length > 0) {
            option = lstOption.map(o => !this.isNullOrBlank(o.PersonalReqPrice) ? +o.PersonalReqPrice : 0).reduce((a, b) => a + b, 0);
            coPriceOption = lstOption.map(o => !this.isNullOrBlank(o.CoReqPrice) ? +o.CoReqPrice : 0).reduce((a, b) => a + b, 0);
            insuranceReqPriceOption = lstOption.map(o => !this.isNullOrBlank(o.InsuranceReqPrice) ? +o.InsuranceReqPrice : 0)
            .reduce((a, b) => a + b, 0);
            otherPriceOption = lstOption.map(o => !this.isNullOrBlank(o.OtherReqPrice) ? +o.OtherReqPrice : 0).reduce((a, b) => a + b, 0);
        }
        if (lstSetItem && lstSetItem.length > 0) {
            setItem = lstSetItem.map(o => !this.isNullOrBlank(o.PersonalCutPrice) ? +o.PersonalCutPrice : 0).reduce((a, b) => a + b, 0);
            coPriceItem = lstSetItem.map(o => !this.isNullOrBlank(o.CoCutPrice) ? +o.CoCutPrice : 0).reduce((a, b) => a + b, 0);
            insuranceReqPriceItem = lstSetItem.map(o => !this.isNullOrBlank(o.InsuranceCutPrice) ? +o.InsuranceCutPrice : 0)
            .reduce((a, b) => a + b, 0);
            otherPriceItem = lstSetItem.map(o => !this.isNullOrBlank(o.OtherCutPrice) ? +o.OtherCutPrice : 0).reduce((a, b) => a + b, 0);
        }
        if (selectedCourse) {
            course = +selectedCourse.PersonalReqPrice;
            coPriceCourse = +selectedCourse.CoReqPrice;
            insuranceReqPriceCourse = +selectedCourse.InsuranceReqPrice;
            otherPriceCourse = +selectedCourse.OtherReqPrice;
        }
        totalA = course + option - setItem;
        coPrice = coPriceCourse + coPriceOption - coPriceItem;
        insuranceReqPrice = insuranceReqPriceCourse + insuranceReqPriceOption - insuranceReqPriceItem;
        otherPrice = otherPriceCourse + otherPriceOption - otherPriceItem;

        let correctAmount = 0;
        if (selectedCourse) {
            if (!this.isNullOrEmpty(selectedCourse.InsuranceReqUpLimitPrice?.trim())
                && insuranceReqPrice > +selectedCourse.InsuranceReqUpLimitPrice
                && +selectedCourse.UplimitCorrectPriceDiv === 1) {
                correctAmount += insuranceReqPrice - +selectedCourse.InsuranceReqUpLimitPrice;
            }
            if (!this.isNullOrEmpty(selectedCourse.CoReqUpLimitPrice?.trim())
                && coPrice > +selectedCourse.CoReqUpLimitPrice
                && +selectedCourse.UplimitCorrectPriceDiv === 1) {
                correctAmount += coPrice - +selectedCourse.CoReqUpLimitPrice;
            }
            if (!this.isNullOrEmpty(selectedCourse.OtherReqUpLimitPrice?.trim())
                && otherPrice > +selectedCourse.OtherReqUpLimitPrice
                && +selectedCourse.UplimitCorrectPriceDiv === 1) {
                correctAmount += otherPrice - +selectedCourse.OtherReqUpLimitPrice;
            }
        }
        return {
            TotalPrice: (totalA + correctAmount),
            CorrectAmount: correctAmount,
        };
    }
    async GetAddress(pPostCode) {
        let postCode = this.ReplaceAll(pPostCode, ' ', '');
        postCode = this.ReplaceAll(postCode, '-', '');
        const dataRes = await this.commonSrv.SearchAddress(postCode).toPromise();
        const lstRet = [];
        for (const it of dataRes) {
            lstRet.push({ Address: it.Address });
        }
        return lstRet;
    }
}
export class AuthorizationData {
    SaveDiv: string;
    HospCode: string;
    HospName: string;
    BasicInfoDiv: string;
    IFTDiagASPInfoDiv: string;
    AMUInfoDiv: string;
    ICTInfoDiv: string;
    IFTMedInfoDevDiv: string;
    NICUInfoDiv: string;
    SSIInfoDiv: string;
    BactInfoDiv: string;
    IsAdmin: boolean;
}
export function isNullOrWhitespace(obj: any): boolean {
    if (!obj) {
        return true;
    }
    if (typeof obj === 'string') {
        return !(obj.trim());
    } else {
        return false;
    }
}

